import React, { useContext } from "react";
import "../css/admin.css";

import { useState } from "react";
import { HashLink } from "react-router-hash-link";
import { useMediaQuery } from "react-responsive";
import CrearRuta from "../components/crearRuta";
import CrearGregario from "../components/CrearGregario";
import CrearCiudad from "../components/CrearCiudad";
import CrearColaborador from "../components/CrearColaborador";
import AdminTracker from "../components/AdminTracker";
import { AuthContext } from "../context/auth.context";
import ActivarDirecto from "../components/ActivarDirecto";

// Components

// import CrearGregario from "../components/gregarios/CrearGregario";
// import CrearCiudad from "../components/ciudades/CrearCiudad";

function Admin() {
  const { isAdmin } = useContext(AuthContext)


  // Media Query
  const activeHashlink = useMediaQuery({ query: "(max-width: 1024px)" });

  // States
  const [crearRuta, setCrearRuta] = useState(false);
  const [crearGregario, setCrearGregario] = useState(false);
  const [crearCiudad, setCrearCiudad] = useState(false);
  const [crearColaborador, setCrearColaborador] = useState(false)
  const [adminTracker, setAdminTracker] = useState(false)
  const [activarDirecto, setActivarDirecto] = useState(false)

  // Toggles
  const handleCrearRuta = () => {
    setCrearRuta(true);
    setCrearGregario(false);
    setCrearCiudad(false);
    setCrearColaborador(false)
    setAdminTracker(false)
    setActivarDirecto(false)
  };
  const handleCrearGregario = () => {
    setCrearRuta(false);
    setCrearGregario(true);
    setCrearCiudad(false);
    setCrearColaborador(false)
    setAdminTracker(false)
    setActivarDirecto(false)
  };

  const handleCrearCiudad = () => {
    setCrearRuta(false);
    setCrearGregario(false);
    setCrearCiudad(true);
    setCrearColaborador(false)
    setAdminTracker(false)
    setActivarDirecto(false)
  };

  const handleCrearColaborador = () => {
    setCrearRuta(false);
    setCrearGregario(false);
    setCrearCiudad(false);
    setCrearColaborador(true)
    setAdminTracker(false)
    setActivarDirecto(false)
  };
  const handleAdminTracker = () => {
    setAdminTracker(true)
    setCrearRuta(false);
    setCrearGregario(false);
    setCrearCiudad(false);
    setCrearColaborador(false)
    setActivarDirecto(false)
  }

  const handleActivarDirecto = () => {
    setActivarDirecto(true)
    setAdminTracker(false)
    setCrearRuta(false);
    setCrearGregario(false);
    setCrearCiudad(false);
    setCrearColaborador(false)
  }


  return (
    <div className="admin">
      {isAdmin && (
        <>

          <div className="button-container">

            <HashLink smooth to="#admin-components">
              <button onClick={handleCrearRuta} className="hash-button">
                Crear Ruta
              </button>
            </HashLink>

            <HashLink smooth to="#admin-components">
              <button onClick={handleCrearGregario} className="hash-button">
                Crear Gregario
              </button>
            </HashLink>

            <HashLink smooth to="#admin-components">
              <button onClick={handleCrearCiudad} className="hash-button">
                Crear Ciudad
              </button>
            </HashLink>

            <HashLink smooth to="#admin-components">
              <button onClick={handleCrearColaborador} className="hash-button">
                Crear Colaborador
              </button>
            </HashLink>

            <HashLink smooth to="#admin-components">
              <button onClick={handleAdminTracker} className="hash-button">
                Tracker
              </button>
            </HashLink>

            <HashLink smooth to="#admin-components">
              <button onClick={handleActivarDirecto} className="hash-button">
                Activar "En DIRECTO"
              </button>
            </HashLink>

          </div>

          <div id={activeHashlink && "admin-components"}>

            {crearRuta && <CrearRuta />}
            {crearGregario && <CrearGregario />}
            {crearCiudad && <CrearCiudad />}
            {crearColaborador && <CrearColaborador />}
            {crearColaborador && <CrearColaborador />}
            {adminTracker && <AdminTracker />}
            {activarDirecto && <ActivarDirecto/>}

          </div>
        </>
      )}

    </div>
  );
}

export default Admin;